import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import '../css/EditUser.css';
import api from '../utils/axiosConfig';

function EditUser() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    name: '',
    code: '',
    email: '',
    institute: '',
    role: '',
    active: true
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    const fetchUser = async () => {
      try {
        const response = await api.get(`/api/users/${id}`);
        const data =  response.data;
        setFormData({
            name: data.name,
            code: data.code,
            email: data.email,
            institute: data.institute,
            role: data.role,
            active: data.active
        });
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };
    fetchUser();
  }, [id]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await api.put(`/api/users/${id}`, formData);
      navigate('/dashboard/users');
    } catch (err) {
      setError(err.message);
    }
  };

  if (loading) return <div className="loading">Loading user data...</div>;
  if (error) return <div className="error">Error: {error}</div>;

  return (
    <div className="edit-user-container">
      <div className="edit-user-card">
        <h1>Benutzer bearbeiten</h1>
        {error && <div className="error-message">{error}</div>}
        <form onSubmit={handleSubmit}>
        <div className="form-group">
            <label htmlFor="code">Code</label>
            <input
              type="text"
              id="code"
              name="code"
              value={formData.code}
              onChange={handleChange}
              pattern="[1-9]{5}[PT]"
              maxLength="6"
              title="Format: 5 digits (1-9) followed by P or T (e.g., 13579P)"
              placeholder="12345P"
              disabled={!!id} // Disable code field when editing
            />
          </div>
          <div className="form-group">
            <label htmlFor="name">Vollständiger Name</label>
            <input
              type="text"
              id="name"
              name="name"
              value={formData.name}
              onChange={handleChange}
              required
            />
          </div>
          
          <div className="form-group">
            <label htmlFor="email">E-Mail</label>
            <input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
            />
          </div>
          
          <div className="form-group">
            <label htmlFor="institute">Institut/Schule</label>
            <input
              type="text"
              id="institute"
              name="institute"
              value={formData.institute}
              onChange={handleChange}
              required
            />
          </div>
          
          <div className="form-group">
            <label htmlFor="role">Rolle</label>
            <select
              id="role"
              name="role"
              value={formData.role}
              onChange={handleChange}
              required
            >
              <option value="">Bitte auswählen</option>
              <option value="teacher">Lehrkraft</option>
              <option value="parent">Elternteil</option>
            </select>
          </div>
          
          <div className="form-group checkbox">
            <input
              type="checkbox"
              id="active"
              name="active"
              checked={formData.active}
              onChange={handleChange}
            />
            <label htmlFor="active">Aktiver Benutzer</label>
          </div>
          
          <div className="form-actions">
            <button type="submit" className="save-button">
              Änderungen speichern
            </button>
            <button 
              type="button" 
              className="cancel-button"
              onClick={() => navigate('/dashboard/users')}
            >
              Abbrechen
            </button>
            <button
              type="button"
              onClick={() => navigate(`/dashboard/users/change-password/${id}`)}
            >
              Passwort für diesen Nutzer ändern
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default EditUser;